import React from "react";
import { HvProvider } from "@hitachivantara/uikit-react-core";
import useTheme from "lib/hooks/useTheme";

// eslint-disable-next-line import/no-extraneous-dependencies
import { sheets } from "jss";

export const ThemeContext = React.createContext<ThemeContextValue>({
  theme: "wicked",
  setTheme: () => undefined,
  toggleTheme: () => undefined,
});

const INIT_LANG = localStorage.getItem("i18n") || "en";

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { theme, setTheme, toggleTheme } = useTheme();

  // we need reset JSS's  global sheets registry because it keeps references
  // to unmounted microapp's style elements and then insertStyle fails
  sheets.reset();

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      <HvProvider uiKitTheme={theme} locale={INIT_LANG}>
        {children}
      </HvProvider>
    </ThemeContext.Provider>
  );
};
